module.exports = __webpack_public_path__ + "img/search_icon.686ccb45.svg";